import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const nivelPuestoImporterSelectors = importerSelectors(
  'nivelPuesto.importer',
);

export default nivelPuestoImporterSelectors;
